const state = {
  isNew:false,
  list: []
};

const mutations = {};

const actions = {
  /**
   * @return {boolean}
   */
  ASetHistory(context, params) {
    let flag = context.state.history.indexOf(params) === -1;
    context.commit("MSetMenu", params);
    return flag
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};




// WEBPACK FOOTER //
// ./src/store/vedio.js